import BigNumber from "bignumber.js";

export const BN_ZERO = new BigNumber(0);
export const BN_ONE = new BigNumber(1);

export const Paths = {
  Landing: {
    Index: "/",
  },
};

export const PUSH_NOTIFICATION_STORAGE_KEY = "push-notification-register-status";
export const REGISTERED = "REGISTERED";

export const LOGIN_URL = "https://a.ntrk2.com/0370a341-69c5-4ae6-a41e-527050feb9c7";
export const REGISTER_URL = "https://a.ntrk2.com/6b699d69-f217-4e11-be9f-28dd6b20e9cd";

export const LOGIN_URL_MAP = {
  "bkk678play.com": "https://a.ntrk2.com/37923164-2dcc-470e-b53f-60573c7fe02f",
  "bkk6788.com": "https://a.ntrk2.com/37923164-2dcc-470e-b53f-60573c7fe02f",
};

export const REGISTER_URL_MAP = {
  "bkk678play.com": "https://a.ntrk2.com/dbb2874f-e751-4d65-9f85-1e3ee8d12a33",
  "bkk6788.com": "https://a.ntrk2.com/dbb2874f-e751-4d65-9f85-1e3ee8d12a33",
};

export const FLOATING_BANNER_URL = "";

export const DOWNLOAD_URL = "https://bkk678.kzw2a.com/download?openExternalBrowser=1&id=m7hxog3t0kdi74j";

export * from "./codes";
export * from "./context";
